export default __webpack_public_path__ + "static/media/Next2.363e82bb.svg";